
import { useEffect, useState } from 'react';
import MiniMainCard from '../MiniMainCard';

const MainCard = ({ MainTitle, data }) => {

    const [showStatus, setShowStatus] = useState(true);

    let signalStrength = data?.rssi?.value  // Assuming data.rssi contains the RSSI value

    useEffect(() => {
        if (signalStrength === undefined) {
            setShowStatus(false);
        }
    }, [signalStrength])

    let networkStatus = null;
    let bgColour = 'bg-placeholder';

    if (signalStrength >= -50) {
        networkStatus = "Excellent";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -60 && signalStrength < -50) {
        networkStatus = "Good";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -70 && signalStrength < -60) {
        networkStatus = "Fair";
        bgColour = 'bg-alertWarning'
    } else if (signalStrength >= -80 && signalStrength < -70) {
        networkStatus = "Weak";
        bgColour = 'bg-alertError'
    } else {
        networkStatus = "Very Weak";
        bgColour = 'bg-alertError'
    }

    return (
        <div className=' w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] border-2 border-dividerLines bg-secondaryBg rounded-md'>
            {MainTitle ? (
                <>
                    <div className=' flex justify-between items-center'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        {showStatus && networkStatus ?
                            <div className={`text-labels text-center text-[10px] 2xl:text-[12px] font-semibold max-w-fit ${bgColour} px-2 py-0.5 rounded-xl`}>
                                <span>{networkStatus}</span>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </>
            )
                : '--'
            }
            <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
            <MiniMainCard
                miniCardData={data}
            />
        </div >
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard